import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { fetchSession } from "@/lib/auth/session";

export type PublicSessionState = "loading" | "authenticated" | "guest";

const PublicSessionContext = createContext<PublicSessionState>("loading");

export function PublicSessionProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<PublicSessionState>("loading");

  useEffect(() => {
    let cancelled = false;
    void fetchSession()
      .then((session) => {
        if (cancelled) return;
        setState(session?.stripe_account_id?.startsWith("acct_") ? "authenticated" : "guest");
      })
      .catch(() => {
        if (!cancelled) setState("guest");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <PublicSessionContext.Provider value={state}>{children}</PublicSessionContext.Provider>
  );
}

export function usePublicSession(): PublicSessionState {
  return useContext(PublicSessionContext);
}
